import { Link } from "react-router-dom";
import {
  MapPin,
  Link2,
  Sparkles,
  MessageCircle,
  Lock,
  ChevronRight,
  Mic,
  UtensilsCrossed,
  Star,
} from "lucide-react";

const items = [
  {
    label: "Locations",
    desc: "Find rooms and sessions",
    icon: MapPin,
    route: "/locations",
    color: "var(--primary)",
    iconColor: "white",
    testid: "more-locations",
  },
  {
    label: "Links",
    desc: "PD platforms & conference site",
    icon: Link2,
    route: "/resources",
    color: "var(--primary-dark)",
    iconColor: "white",
    testid: "more-resources",
  },
  {
    label: "AI Online Learning Games",
    desc: "Hands-on AI games for the classroom",
    icon: Sparkles,
    route: "/ai-games",
    color: "var(--gold)",
    iconColor: "var(--primary-dark)",
    testid: "more-ai-games",
  },
  {
    label: "Feedback",
    desc: "Share your thoughts",
    icon: MessageCircle,
    route: "/feedback",
    color: "var(--maroon)",
    iconColor: "white",
    testid: "more-feedback",
  },
];

export default function More() {
  return (
    <div
      style={{ padding: "16px", paddingBottom: "40px" }}
      data-testid="more-page"
    >
      <p
        style={{
          fontSize: "12px",
          fontWeight: 800,
          letterSpacing: "1.5px",
          color: "var(--primary)",
          textTransform: "uppercase",
          marginBottom: "12px",
        }}
      >
        Explore More
      </p>

      {items.map((it) => {
        const Icon = it.icon;
        return (
          <Link
            key={it.label}
            to={it.route}
            data-testid={it.testid}
            className="flex items-center"
            style={{
              backgroundColor: "var(--surface)",
              borderRadius: "14px",
              padding: "14px",
              marginBottom: "10px",
              border: "1px solid var(--border)",
            }}
          >
            <div
              className="flex items-center justify-center"
              style={{
                width: "44px",
                height: "44px",
                borderRadius: "12px",
                backgroundColor: it.color,
                marginRight: "12px",
              }}
            >
              <Icon size={22} color={it.iconColor} strokeWidth={2} />
            </div>
            <div className="flex-1">
              <p
                style={{
                  fontWeight: 700,
                  color: "var(--primary-dark)",
                  fontSize: "16px",
                }}
              >
                {it.label}
              </p>
              {it.desc && (
                <p
                  style={{
                    color: "var(--text-muted)",
                    fontSize: "13px",
                    marginTop: "2px",
                  }}
                >
                  {it.desc}
                </p>
              )}
            </div>
            <ChevronRight size={22} color="var(--text-muted)" />
          </Link>
        );
      })}

      <div
        className="flex flex-col items-center"
        style={{ marginTop: "32px" }}
      >
        <p
          style={{
            color: "var(--primary)",
            fontWeight: 800,
            fontSize: "14px",
            letterSpacing: "1px",
          }}
        >
          Success Starts Here
        </p>
        <p
          style={{
            color: "var(--text-muted)",
            fontSize: "12px",
            marginTop: "4px",
          }}
        >
          Nurture. Guide. Empower. · 2026
        </p>
      </div>
    </div>
  );
}
